const { fetcher } = require('services/helpers/responseHandler')
const {
  normalizeCampaignEmailParams
} = require('features/EmailEditor/campaignEmailCustomizationHelpers')
const { normalizeNotificationGlobalParams } = require('features/EmailEditor/utils')

function normalizeTemplateListItem(item = {}) {
  return {
    id: item.id ?? item.Id,
    name: item.name ?? item.Name ?? '',
    isActive: Boolean(item.isActive ?? item.IsActive),
    shellTemplateKey: item.shellTemplateKey ?? item.ShellTemplateKey ?? ''
  }
}

function normalizeTemplateListResponse(data = {}) {
  const templates = data.templates ?? data.Templates ?? []

  return {
    templates: templates.map(normalizeTemplateListItem),
    needsInitialApply: Boolean(data.needsInitialApply ?? data.NeedsInitialApply)
  }
}

function normalizeTemplateDetail(data = {}) {
  return {
    id: data.id ?? data.Id,
    name: data.name ?? data.Name ?? '',
    isActive: Boolean(data.isActive ?? data.IsActive),
    shellTemplateKey: data.shellTemplateKey ?? data.ShellTemplateKey ?? '',
    emailParams: normalizeCampaignEmailParams(data.emailParams ?? data.EmailParams ?? {}),
    globalParams: normalizeNotificationGlobalParams(data.globalParams ?? data.GlobalParams ?? {}),
    html: data.html ?? data.Html ?? ''
  }
}

function coerceTemplateId(templateId) {
  const resolvedId = Number(templateId)
  return Number.isFinite(resolvedId) ? resolvedId : templateId
}

const listTemplates = async () => {
  const data = await fetcher.get('content/invite-email-design/templates')
  return normalizeTemplateListResponse(data || {})
}

const createTemplate = async ({ name, sourceTemplateId, shellTemplateKey }) =>
  fetcher.post('content/invite-email-design/templates', {
    name,
    sourceTemplateId,
    shellTemplateKey
  })

const getTemplate = async ({ templateId }) => {
  const data = await fetcher.get(
    `content/invite-email-design/templates/${coerceTemplateId(templateId)}`
  )

  return normalizeTemplateDetail(data || {})
}

const updateTemplate = async ({ templateId, name, emailParams, html, globalParams }) =>
  fetcher.put(`content/invite-email-design/templates/${coerceTemplateId(templateId)}`, {
    name,
    emailParams,
    html,
    globalParams
  })

const activateTemplate = async ({ templateId }) =>
  fetcher.put(
    `content/invite-email-design/templates/${coerceTemplateId(templateId)}/activate`
  )

const deleteTemplate = async ({ templateId }) =>
  fetcher.del(`content/invite-email-design/templates/${coerceTemplateId(templateId)}`)

const applyTemplate = async ({ templateId, scope }) =>
  fetcher.put('content/invite-email-design/apply', {
    templateId: coerceTemplateId(templateId),
    scope: Number(scope)
  })

export const INVITE_EMAIL_DESIGN_APPLY_SCOPES = {
  all: 0,
  ota: 1,
  direct: 2
}

export default {
  listTemplates,
  createTemplate,
  getTemplate,
  updateTemplate,
  activateTemplate,
  deleteTemplate,
  applyTemplate,
  INVITE_EMAIL_DESIGN_APPLY_SCOPES
}
